import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { Formik, Form } from "formik";
import * as Yup from 'yup';
import MyTextInput from "../../app/common/form/MyTextInput";
import { createCATCursos } from "../../app/models/CATCursos";
import { Header,  Segment } from "semantic-ui-react";
import { useStore } from '../../app/stores/store';
import { Message } from 'semantic-ui-react'
import { createPermisostoRolFormValues, listPermisos } from "../../app/models/Roles";

let permisosArreglo: number[] = []
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    button: {
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    actionsContainer: {
      marginBottom: theme.spacing(2),
    },
    resetContainer: {
      padding: theme.spacing(3),
    },
  }),
);

function getSteps() {
  return ['Información general', 'Permisos'];
}

export default observer(function CreateRoles() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();
  

  const {RolesStore} = useStore();
  const {createRoles, AllPermissions, assinPermissionsToRol} = RolesStore

  useEffect(() => {
    AllPermissions()
  }, []);

  const handleReset = () => {
    setActiveStep(0);
  };

  function getStepContent(step: number) {

    function handleNext1(valor: any){
      setActiveStep(1);
      createRoles(valor["nombre"]).then(() => {
      })
    };

    function handleNext2(){
      permisosArreglo = []
      setActiveStep(2);
      RolesStore.PermisoByCodigo.map((item: listPermisos) => {
        var inputSelect = (document.getElementById(item.permiso) as HTMLInputElement)
        if (inputSelect.checked == true){
          permisosArreglo.push(item.id)
        }
      })
      let newPermisostoRol: createPermisostoRolFormValues = {
        rolId: RolesStore.id,
        permisos: permisosArreglo
      }
      assinPermissionsToRol(newPermisostoRol)
    };

    const validationSchema = Yup.object({
      nombre: Yup.string().required('Obligatorio')
    })

    switch (step) {
      case 0:
        return (
          <>
            <div className="pagina_formulario">
              <Segment className="contenedor_formulario">
                <Formik validationSchema={validationSchema}
                        enableReinitialize 
                        initialValues={createCATCursos} 
                        onSubmit={values => {
                          handleNext1(values)
                        }}>
                  {({handleSubmit, isValid, isSubmitting, dirty}) => (
                    <Form className='ui form' onSubmit={handleSubmit} autoComplete='off'>
                      <div>
                        <Header size="small" content="Nombre del rol" />
                        <MyTextInput id="nombreRol" name='nombre' placeholder='' />
                      </div>
                      <br></br>
                      <div>
                        <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        className={classes.button}
                        >Siguiente</Button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </Segment>
            </div>
          </>
        );
      case 1:
        return (
          <>
            <div className="pagina_formulario">
              <Segment className="contenedor_formulario">
                <div>
                  {RolesStore.PermisoByCodigo.map((item: listPermisos) => {
                    return(
                      <form key={item.id}>
                        <input type="checkbox" value={item.id} id={item.permiso}></input>
                        <label>{" " + item.permiso}</label>
                        <br></br>
                      </form>
                    )
                  })}
                </div>
                <Button
                  onClick={handleNext2}
                  variant="contained"
                  color="primary"
                  type="submit"
                  className={classes.button}
                >Terminar</Button>
              </Segment>
            </div>
          </>
        );
      default:
        return 'No existe';
    }
  }
  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} orientation="vertical">
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
            <StepContent>
              <div>{getStepContent(index)}</div>
            </StepContent>
          </Step>
        ))}
      </Stepper>
      {activeStep === steps.length && (
        <Paper square elevation={0} className={classes.resetContainer}>
          <Message color='green'>
            <Message.Header>¡Todos los pasos han sido completados correctamente!</Message.Header>
          </Message>
          <Button onClick={handleReset} variant="contained" className={classes.button}>
            Crear otro rol
          </Button>
        </Paper>
      )}
    </div>
  );
})
